/**
 * @typedef { object } GroupStyle
 * @property { number } id
 * @property { number } count
 * @property { string } fillColor
 * @property { string } strokeColor
 * @property { number } strokeWidth
 * @property { string } groupLabel
 * @property { number } groupValueLabel
 * @property { number } groupValue
 * @property { number } radius
 */

/**
 * @typedef { object } Classification
 * @property { string } classificationType
 * @property { Geostats } groups
 * @property { number } precision
 * @property { number } nbGroupes
 */

/**
 * @typedef { string } FeatureType
 */
